export default __webpack_public_path__ + "static/media/ill-courses.9ccbfb0f.png";